import logger from '../logger';
import AxiosChatNotificationsInstance from '../../api/AxiosChatNotificationsInstance';
import {LS_PUSH_SUBSCRIPTIONS, SUBSCRIPTION_ID} from './constants';

const notificationsService = {
  async updatePushSubscription(subscription: string | void): Promise<void> {
    const currentSubscription = sessionStorage.getItem(LS_PUSH_SUBSCRIPTIONS);

    if (subscription && JSON.stringify(subscription) !== currentSubscription) {
      await this.deletePushSubscription();

      sessionStorage.setItem(LS_PUSH_SUBSCRIPTIONS, JSON.stringify(subscription));
    }

    try {
      const subscriptionId = await AxiosChatNotificationsInstance.post<any, string>(
        '/notifications/subscribe',
        subscription
      );
      if (subscriptionId) {
        sessionStorage.setItem(SUBSCRIPTION_ID, subscriptionId);
      }
    } catch (error) {
      logger.error('Subscription request failed', error);
    }
  },

  async deletePushSubscription(): Promise<void> {
    const subscriptionSerialized = sessionStorage.getItem(LS_PUSH_SUBSCRIPTIONS);
    const subscriptionId = sessionStorage.getItem(SUBSCRIPTION_ID);

    if (!subscriptionSerialized && subscriptionSerialized !== 'undefined') {
      return;
    }

    let subscription = null;

    try {
      subscription = JSON.parse(subscriptionSerialized);
    } catch (err) {
      logger.warn('Subscription parse error', err);
    }

    if (subscription) {
      sessionStorage.removeItem(LS_PUSH_SUBSCRIPTIONS);

      await AxiosChatNotificationsInstance.post('/notifications/unsubscribe', {
        subscriptionId,
      });
    }
  },
};

export default notificationsService;
